export default __webpack_public_path__ + "static/media/icon-arrow-down.2ee27cf2.svg";